import { useRef, useState } from "react";
import { listNav, listNavMenu } from "../../utils/configData";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { fetchLogout } from "../../pages/FetchAuth";
import { updateUserInfo } from "../../store/actions/userAction";
import { useDispatch } from "react-redux";

function BurgerMenu({ className = "", checkActive, location }) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const userInfo = useSelector((state) => state.user);
    const refWrapper = useRef(null);
    const dispatch = useDispatch();
    const toggle = () => {
        refWrapper.current.classList.toggle("active");
        if (isOpen) {
            document.body.style.overflow = "unset";
        } else {
            document.body.style.overflow = "hidden";
        }
        setIsOpen(!isOpen);
    };

    const logout = () => {
        fetchLogout().then((data) => {
            updateUserInfo(dispatch, data.userData);
            toggle();
        });
    };


    return (
        <div ref={refWrapper} className={`burger-menu ${className}`}>
            <button onClick={toggle} className="burger-menu__button"><i className="ri-menu-2-line"></i><i className="ri-close-line"></i></button>
            <div className="burger-menu__wrapper">
                <h3>{t("Menu")}</h3>
                {
                    listNav.map((item, index) => (
                        !item.isExternal ? (
                            userInfo.type === 1 && item.url === "/" ? null : (<NavLink onClick={toggle} className={({ isActive }) => (isActive || checkActive(location, item.url) ? "active" : "")} key={index} to={item.url}>{item.name}</NavLink>)
                        ) : (
                            <a onClick={toggle} key={index} href={item.url} rel="noreferrer" target="_blank">{item.name}</a>
                        ))
                    )}
                <div className="line-x"></div>
                {
                    listNavMenu.map((item, index) => (
                        !item.isExternal ? (
                            <NavLink onClick={toggle} key={index} to={item.url}>{item.name}</NavLink>
                        ) : (
                            <a onClick={toggle} key={index} href={item.url} rel="noreferrer" target="_blank">{item.name}</a>
                        ))
                    )}

                <Link to="/sign-in" onClick={logout}>
                    {t("Log out")}
                </Link>
            </div>
        </div>
    );
}

export default BurgerMenu;